import { render, staticRenderFns } from "./SocioDetalle.vue?vue&type=template&id=cedb7c2e&scoped=true"
import script from "./SocioDetalle.vue?vue&type=script&lang=js"
export * from "./SocioDetalle.vue?vue&type=script&lang=js"
import style0 from "./SocioDetalle.vue?vue&type=style&index=0&id=cedb7c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedb7c2e",
  null
  
)

export default component.exports